let isFinancial = ['2', '3'].includes(sessionStorage.getItem('roleId'));
export const amtReg = isFinancial ? /^((-{0,1}[1-9]\d*(.\d{1,2})?)|(-{0,1}0.0[1-9]|0.[1-9]\d?))$/ : /^(([1-9]\d*(.\d{1,2})?)|(0.0[1-9]|0.[1-9]\d?))$/;
export const amtRegMessage = isFinancial ? '不为0，最多两位小数' : '大于等于0.01，最多两位小数';
// export const badQQEmailReg = /@(((qq|99)[\.,。]?(c0n|cm|can|cqn|con))|(99\.com))$/;
//不以！右边字符串结尾
//qq邮箱验证
export const goodQQEmailReg = /.*?(?<!(@(((qq|99)[\.,。]?(c0n|cm|can|cqn|con|c0m|c1m|c2m|c3m|c4m|c5m|c6m|c7m|c8m|c9m))|(99|q\.com))))$/;

export const billNameReg = /[&/*，,•.。\\]/;
export const billNameRegMsg = '不能包含 &/*，,•.\\等特殊符号 ，请检查！';

//邮箱验证正则
export const emailReg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
